import { useContext, useEffect, useState } from 'react';
import { Container, Table } from 'react-bootstrap';
import Navigation from '../../../Components/Navbar';
import api from '../../../Components/Api/Api';
import "./servicos.scss";
import Spinner from "../../../Components/Spinner";
import { Link, useLocation } from 'react-router-dom';
import { UserContext } from '../../../context/UserContext';

const OficinaItens = () => {
    const location = useLocation();
    const {user} = useContext(UserContext)
    const orcamento = location.state;    
    const [atualizar, setAtualizar] = useState(false)  
    const [ShowLoading, setShowLoading] = useState(false)  
    const [orcamentos, setOrcamentos] = useState([])
    const credentials = btoa(`${user.userRest}:${user.passRest}`); 
    const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "User-Agent": "PneusBrasil",
        "Accept": "application/json",
        'Authorization': `Basic ${credentials}`
    }     
    function getentradas () {
            setTimeout(() => {
            setShowLoading(true)
                api.get('Ordemservicoitens?filial='+user.filial+'&Orcamento='+orcamento,{headers})
                .then(response => {
                    //console.log(response.data.Entradas)
                    if (response.data.Ordens.length > 0 ){   
                        //console.log(response.data.Entradas[0]['Num'])  
                        setOrcamentos(response.data.Ordens)
                        setAtualizar(true) 
                        setShowLoading(false)  
                        //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
                    }else{
                        //setInfoveuculo('Placa não cadastrada!')
                        setShowLoading(false)
                        setAtualizar(true)
                    }                                   
                });
            }, 10 );        
    };

    useEffect(() => {
        if(!atualizar){
        getentradas()
        }
    })   
    return (
      <>
        <Navigation /> 
        <Container>
            <div className='mt-4'>    
                <Table striped bordered hover variant="light" responsive className="tabela">
                <thead>
                    <tr className='col-title'>
                    <th>Id</th>
                    <th>Produto</th>
                    <th>Descrição</th>
                    <th>Tipo</th> 
                    </tr>
                </thead> 
                <tbody> 
                {orcamentos.map((list: any) => (           
                    <tr key={list.id}>
                    <td>{list.id}</td>
                    <td>{list.produto}</td>
                    <td>{list.descricao}</td>
                    <td>{list.tipo}</td>
                    </tr>
                ))}                         
                </tbody>
                </Table>       
                <Spinner isLoading={ShowLoading} />                       
            </div>
            <button><Link to='/Oficina'>Voltar</Link></button>
        </Container>       
      </>  
    );
};

export default OficinaItens;